import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';
import { useAnimate, motion, useAnimation } from "framer-motion";
import Card from '@mui/material/Card';

function Copyright(props) {
    return (
        <>
            <Typography sx={{ mt: 7, mb: 1 }} variant="body2" color="text.secondary" align="center" {...props}>
                {'Slot Machine Prototype Version 0.1'}
            </Typography>
            <Typography sx={{ mt: 2, mb: 1 }} variant="body2" color="text.secondary" align="center" {...props}>
                {'Copyright © Ricardo Herrklotz '}
                {new Date().getFullYear()}
                {'.'}
            </Typography>
        </>
    );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

function Login({ callbackLogin }) {
    const [fullscreen, setFullscreen] = useState(true);
    const [sound, setSound] = useState(true);
    const [devView, setDevView] = useState(false);
    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        callbackLogin(data.get('name'), fullscreen, sound, devView);
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    height={"100%"}
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <motion.div
                        className="symbol"
                        //key={k++}
                        width="100%"
                        height="100%"
                        style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL}/Images/Icon.png) `,
                            //backgroundImage: `url(${process.env.PUBLIC_URL + '/Images/1.png'})`,
                            width: '128px',
                            height: '128px',
                            backgroundSize: "cover",
                            backgroundPosition: 'center right',
                            //background: 'linear-gradient(to top, rgba(0, 0, 0, 0), rgba(255, 255, 255, 0.5))'
                            mb: 10
                        }}
                        //variants={aVariants}
                        animate={{
                            y: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 5,
                            type: "spring",
                            stiffness: 750
                        }}
                        initial={{
                            y: 200,
                            opacity: 0.5
                        }}
                    //initial={{y:-100, opacity: 0}}
                    //animate={{ y: 0, opacity: 100 }}
                    //transition={{ duration: 0.2, type: "spring", stiffness: 750, delay: i/10 }}
                    ></motion.div>

                    <Typography component="h1" variant="h5" sx={{ mt: 4 }}>
                        Slot Machine Game Prototype
                    </Typography>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{  mt: 4 }}>
                        <TextField
                            margin="normal"
                            fullWidth
                            id="name"
                            label="Name"
                            name="name"
                            autoComplete="name"
                            autoFocus
                            required
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'col', justifyContent: 'space-between', mt: 4 }}>
                            <FormControlLabel
                                control={<Checkbox value="fullscreen" color="primary" onChange={(e) => setFullscreen(e.target.value)} defaultChecked />}
                                label="Fullscreen"
                            />
                            <FormControlLabel
                                control={<Checkbox value="sound" color="primary" onChange={(e) => setSound(!sound)} defaultChecked />}
                                label="Sound"
                            />
                            <FormControlLabel
                                control={<Checkbox value="devView" color="primary" onChange={(e) => setDevView(!devView)} />}
                                label="Development"
                            />
                        </Box>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 5, mb: 3, fontSize: '25px' }}
                        >
                            Start Game
                        </Button>
                    </Box>
                </Box>
                <Copyright />
            </Container>
        </ThemeProvider>
    );
}

export default Login;